import Vue from 'vue'
import AppointmentButtonCallLpu from 'www/vue_components/common/AppointmentButtonCallLpu/AppointmentButtonCallLpu.vue'

export default function renderCallButton(opts) {
  const {
    lpuPhone,
    lpuWorkingText,
    serviceIsExpress,
    scheduleContainer,
  } = opts

  if (
    window.MOBILE_VERSION
    && serviceIsExpress
    && lpuPhone
  ) {
    scheduleContainer.innerHTML = '<div class="schedule-button"></div>'

    new Vue({
      el: scheduleContainer.querySelector('.schedule-button'),
      render: h => h(AppointmentButtonCallLpu, {
        props: {
          phone: lpuPhone,
          lpuWorkingText,
        },
      }),
    })
  }
}
